<template>
  <div class="exhibitiorDetail">
    <MobileHead />
    <div class="productsDetail">
      <div class="nav">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/index' }">{{ $t('navbar.home') }}</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/exhibitsList' }">{{ $t('navbar.exhibits') }}</el-breadcrumb-item>
          <el-breadcrumb-item :style="{ maxWidth: lang == 'zh' ? '55vw' : '43vw' }"
            ><span style="color:#006FB8; font-weight: 400;">{{ lang == 'zh' ? exhibitInfo.exhibitsName : exhibitInfo.column25 }}</span></el-breadcrumb-item
          >
        </el-breadcrumb>
      </div>
      <div class="parduct_intr">
        <div class="lunbo">
          <!-- 轮播开始 -->
          <!--v-if判断一下，实现loop-->
          <swiper v-if="lunboImg.length >= 1" :options="swiperOption" ref="mySwiper">
            <swiper-slide v-for="(item, index) in lunboImg" :key="index">
              <img v-if="item.url.substr(0,4) == 'http' " :src="item.url" alt="" />
              <img v-else :src="baseUrl + item.url" alt="" />
            </swiper-slide>
            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </div>
        <div class="introduce">
          <div class="title">
            <div class="titleContent">{{ lang == 'zh' ? exhibitInfo.exhibitsName : exhibitInfo.column25}}</div>
            <!-- <div class="border"></div> -->
          </div>
          <p :title="exhibitInfo.column23">
            <span> {{ $t('exhibits.productModel') }}</span
            >{{ exhibitInfo.column23 }}
          </p>
          <p :title="exhibitInfo.seriesName">
            <span> {{ $t('exhibits.prosuctSeries') }} </span>{{ exhibitInfo.seriesName }}
          </p>
          <p :title="exhibitInfo.column17 + '/' + exhibitInfo.column18 + '/' + exhibitInfo.column19">
            <span> {{ $t('exhibits.productCategory') }} </span>{{ exhibitInfo.column17 }} / {{ exhibitInfo.column18 }} / {{ exhibitInfo.column19 }}
          </p>
          <div class="exhibitor" @click="goDetail()">
            <div class="logo">
              <img :src="exhibitorInfo.comCover" alt="" v-if="exhibitorInfo.comCover.substr(0,4) == 'http'" />
              <img :src="baseUrl + exhibitorInfo.comCover" alt="" v-else />
              <!-- <img src="../../../static/占位-展商-列表.png" alt="" v-else /> -->
            </div>
            <div class="exhi_title">
              <p>{{ lang == 'zh' ? exhibitorInfo.companyNameC : exhibitorInfo.companyNameE }}</p>
              <p :title="exhibitorInfo.boothList" v-if="exhibitorInfo.boothList" class="boothnum">
                {{ $t('common.boothNum1') }}&nbsp;&nbsp;<span
                  style="color: #333333;font-weight:600"
                  v-for="(item, index) in exhibitorInfo.boothList"
                  :key="index"
                  >{{ item }} &nbsp;</span
                >
              </p>
            </div>
          </div>
        </div>
      </div>
      <van-tabs v-model="active" scrollspy sticky offset-top="13.3vw">
        <van-tab :title="$t('exhibits.productIntroduce')">
          <div id="item1">
            <h3 :style="{ width: lang == 'zh' ? '24.27vw' : '45vw' }">{{ $t('exhibits.productIntroduce') }}</h3>
            <div v-html="lang == 'zh' ? exhibitInfo.exhibitsIntro : exhibitInfo.exhibitsIntroE" class="content"></div>
            <div class="vedio" v-if="exhibitInfo.column21">
              <video :src="baseUrl + exhibitInfo.column21" class="shipin" :poster="baseUrl + exhibitInfo.column20" controls="controls">
                your browser does not support the video tag
              </video>
            </div>
          </div>
        </van-tab>
        <van-tab :title="$t('exhibits.productParameter')" v-if="exhibitInfo.techParam">
          <div id="item2" v-if="exhibitInfo.techParam">
            <h3 :style="{ width: lang == 'zh' ? '24.27vw' : '37vw' }">{{ $t('exhibits.productParameter') }}</h3>
            <el-table v-html="exhibitInfo.techParam" class="tableDate"></el-table>
          </div>
        </van-tab>
        <van-tab :title="$t('exhibits.productTravelBrochure')" v-if="exhibitInfo.exhibitsAttachList.length > 0">
          <div id="item3" v-if="exhibitInfo.exhibitsAttachList.length >= 1">
            <h3 class="hstyle" :style="{ width: lang == 'zh' ? '35vw' : '70vw' }">{{ $t('exhibits.productTravelBrochure') }}</h3>
            <div class="down_box">
              <div class="down_thend">
                <p>{{ $t('exhibits.infoName') }}</p>
                <p>{{ $t('common.options') }}</p>
              </div>
              <div class="down_file down_thend" v-for="(item, index) in exhibitInfo.exhibitsAttachList" :key="index">
                <p>{{ item.name }}</p>
                <p>
                  <a @click="download(item.name, item.url)">{{ $t('common.download') }}</a>
                </p>
              </div>
            </div>
            <div v-if="moreMaterial" class="more" @click="getMoreMaterial()">{{ $t('exhibition.openMore') }}<span class="icon_more"></span></div>
          </div>
        </van-tab>
        <van-tab :title="$t('exhibits.other')">
          <div id="item4" v-if="this.RecommendExhibits.length > 0">
            <h3 :style="{ width: lang == 'zh' ? '24.27vw' : '40vw' }">{{ $t('exhibits.other') }}</h3>
            <div class="other_product">
              <other-product :zsId="zsId" :zpId="id" :lang="lang" />
            </div>
          </div>
        </van-tab>
      </van-tabs>
      <!-- <div class="itemInfo">
        <div id="item1">
          <h3 :style="{ width: lang == 'zh' ? '24.27vw' : '45vw' }">{{ $t('exhibits.productIntroduce') }}</h3>
          <div v-html="exhibitInfo.exhibitsIntro" class="content"></div>
          <div class="vedio" v-if="exhibitInfo.column21">
            <video :src="baseUrl + exhibitInfo.column21" class="shipin" :poster="baseUrl + exhibitInfo.column20" controls="controls">
              your browser does not support the video tag
            </video>
          </div>
        </div>
        <div id="item2" v-if="exhibitInfo.techParam">
          <h3 :style="{ width: lang == 'zh' ? '24.27vw' : '37vw' }">{{ $t('exhibits.productParameter') }}</h3>
          <el-table v-html="exhibitInfo.techParam" class="tableDate"></el-table>
        </div>
        <div id="item3" v-if="exhibitInfo.exhibitsAttachList.length >= 1">
          <h3 class="hstyle" :style="{ width: lang == 'zh' ? '35vw' : '70vw' }">{{ $t('exhibits.productTravelBrochure') }}</h3>
          <div class="down_box">
            <div class="down_thend">
              <p>{{ $t('exhibits.infoName') }}</p>
              <p>{{ $t('common.options') }}</p>
            </div>
            <div class="down_file down_thend" v-for="(item, index) in exhibitInfo.exhibitsAttachList" :key="index">
              <p>{{ item.name }}</p>
              <p>
                <a @click="download(item.name, item.url)">{{ $t('common.download') }}</a>
              </p>
            </div>
          </div>
          <div v-if="moreMaterial" class="more" @click="getMoreMaterial()">{{ $t('exhibition.openMore') }}<span class="icon_more"></span></div>
        </div>
        <div id="item4">
          <div class="other_product">
            <other-product :zsId="zsId" :zpId="id" :lang="lang" />
          </div>
        </div>
      </div> -->
    </div>
    <div class="fun">
      <div class="collent_btn">
        <button class="shoucang" @click="consult(exhibitorInfo)">{{ $t('common.consult') }}</button>
        <button class="shoucang3" @click="collent(exhibitInfo)" v-if="exhibitInfo.collectStatus">{{ $t('common.collected') }}</button>
        <button class="shoucang2" @click="collent(exhibitInfo)" v-else>{{ $t('common.collectExhibits') }}</button>
        <div class="share" @click="goShare">
          <div class="shareLogo"><img src="../../../static/share.png" alt="" /></div>
          <div class="shareTxt">{{ $t('common.share') }}</div>
        </div>
      </div>
    </div>
    <GoLogin :dialogVisible.sync="dialogVisible" @func="getMsgFormSon" @funcancel="getCancel" />
    <DownloadFile :title.sync="fileTitle" :downloadVisable.sync="downloadVisable" @downCancel="downCancel" @downFile="downFile" />
    <Share
      :shareVisiable="shareVisiable"
      @copyLink="copyLink"
      @closePannel="closePannel"
      :shareContentTitle="shareContentTitle"
      :shareContentUrl="shareContentUrl"
    />

    <Foot style="margin-bottom:15.2vw" />
  </div>
</template>

<script>
import MobileHead from '../../../common/mobile/head.vue';
import Foot from '../../../common/mobile/footBottom.vue';
import { getExhibit, getExhibitor, collecExhibit, getOtherEx } from '../../../../api/exhibitProduct.js';
import { forMat } from '../../../../utils/common.js';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';
import otherProduct from './otherProduct.vue';
import GoLogin from '../../../common/mobile/goLogin.vue'; //登录提示框
import * as tools from '../../../../utils/roulink';
import Share from '../../../common/mobile/share.vue';
import DownloadFile from '../../../common/mobile/download.vue';

export default {
  name: '',
  components: { MobileHead, Foot, GoLogin, swiper, swiperSlide, otherProduct, Share, DownloadFile },

  data() {
    return {
      baseUrl: forMat(),
      id: this.$route.query.id,
      active: 0,
      shareVisiable: false, //弹出分享面板
      zsId: '',
      // 展品信息
      exhibitInfo: {
        techParam: '',
        exhibitsName: '1', //展品名称
        column23: '', //展品型号
        seriesName: '', //展品系列
        column17: '', //展品类别
        exhibitsIntro: '', //展品介绍
        exhibitsAttachList: [], //展品宣传资料
      },
      RecommendExhibits: '', // 其他产品
      moreMaterial: false,
      list: [],
      //需要轮播的图片
      lunboImg: [],
      exhibitorInfo: {
        companyNameC: '', // 中文名称
        comCover: '', //公司Logo
        boothList: [], //展位号
      },
      swiperOption: {
        loop: true,
        autoplay: true,
        // 显示分页
        pagination: {
          el: '.swiper-pagination',
          clickable: true, //允许分页点击跳转
          bulletActiveClass: 'my-bullet-active',
        },
        // 设置点击箭头
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
      dictionaries: {
        展品介绍: 'item1',
        展品参数: 'item2',
        展品宣传资料: 'item3',
        其他展品: 'item4',
      },
      lang: '',
      dialogVisible: false,
      shareContentTitle: '',
      shareContentUrl: '',
      fileTitle: '',
      downloadVisable: false,
      consultFlag: false,
      consultId: '',
    };
  },
  created() {
    this.getInitData();
    this.isActive();
    this.lang = localStorage.getItem('lang');
    document.documentElement.scrollTop = 0;
    window.scrollTo(0, 0);
  },
  watch: {
    $route(to, from) {
      //监听相同路由下参数变化的时候，从而实现异步刷新
      this.id = this.$route.query.id;
      //重新获取数据
      this.getInitData();
      // this.isActive()
    },
  },
  methods: {
    downCancel(data) {
      this.downloadVisable = data;
    },
    downFile(data) {
      const url = this.downFileName;
      this.downloadVisable = data;
      const isToken = localStorage.getItem('viewToken'); //观众
      const zsToken = localStorage.getItem('token'); //展商
      if (isToken != '' && isToken != null) {
        let fileUrl = this.baseUrl + url;
        const link = document.createElement('a');
        link.setAttribute('download', 'download');
        link.setAttribute('href', fileUrl);
        link.click();
      } else {
        this.dialogVisible = true;
      }
    },
    //下载展商文件
    download(name, url) {
      this.fileTitle = name;
      this.downFileName = url;
      this.downloadVisable = true;
    },
    // 复制链接
    closePannel(data) {
      this.shareVisiable = data;
    },
    copyLink() {},
    goShare() {
      this.shareVisiable = true;
      this.shareContentTitle = this.exhibitInfo.exhibitsName;
      this.shareContentUrl = window.location.href;
    },
    async collent(item) {
      // item.collectStatus = !item.collectStatus;
      // console.log("展品参数",item);
      const willStatus = !item.collectStatus;
      // 添加或者取消收藏
      const params = {
        objId: item.id,
        flag: willStatus,
        type: 2,
      };
      // const toggleStatus = item.collectStatus === true ? true : false;
      try {
        const { data } = await collecExhibit(params);
        if (data.code === 200) {
          if (!item.collectStatus) {
            item.collectStatus = !item.collectStatus;
            this.$message({
              showClose: true,
              message: this.$t('common.successCollect'),
              type: 'success',
            });
          } else {
            item.collectStatus = !item.collectStatus;
            this.$message({
              showClose: true,
              message: this.$t('common.cancelCollect'),
              type: 'error',
            });
          }
          this.getOtherExInfo();
        } else {
          // tools.login(3);
        }
      } catch (err) {
        if (err == 'noLogin') {
          this.dialogVisible = true;
        }
        // console.log(err);
      }
    },
    getCancel(data) {
      this.dialogVisible = data;
    },
    getMsgFormSon(data) {
      this.dialogVisible = data;
      if (this.consultFlag) {
        tools.login(1, this.consultId);
      } else {
        tools.login(3);
      }
    },
    consult(item) {
      this.consultFlag = true;
      this.consultId = item.id;
      const viewToken = localStorage.getItem('viewToken');
      const token = localStorage.getItem('token');
      if (!viewToken && !token) {
        this.dialogVisible = true;
      }
      if (viewToken) {
        tools.login(1, item.id);
      }
      if (token && !viewToken) {
        this.$message({
          showClose: true,
          message: this.$t('message.isLimit'),
          type: 'error',
        });
        return;
      }
    },
    // 跳转展商详情
    goDetail() {
      this.$router.push({
        name: 'exhibition_det',
        query: {
          id: this.exhibitInfo.hzExhibitorId,
        },
      });
    },
    isActive() {
      const key = window.location.href.includes('exhibItem_detail');
      // this.active[key] = true;
    },
    getMoreMaterial() {},
    // 获取展品信息
    async getInitData() {
      window, scrollTo(0, 0);
      this.lunboImg = [];
      const params = {
        id: this.id,
      };
      try {
        const { data } = await getExhibit(params);
        if (data.code === 200) {
          this.exhibitInfo = data.data;
          if (data.data?.exhibitsImg.includes(',')) {
            data.data?.exhibitsImg.split(',').map((item) => {
              this.lunboImg.push({
                url: item,
              });
            });
          } else {
            const img = data.data?.exhibitsImg;
            this.lunboImg = [{ url: img }];
          }

          this.getExhibitorInfo(data.data.hzExhibitorId);
          this.zsId = data.data.hzExhibitorId;
          this.getotherProduct();
        }
      } catch (err) {
        console.log(err);
      }
    },
    //获得其他展品信息
    async getotherProduct() {
      const params = { exhibitsId: this.id, exhibitorId: this.zsId };
      try {
        const { data } = await getOtherEx(params);
        this.RecommendExhibits = data.data;
        // console.log("其他展品",data);
      } catch (err) {
        console.log(err);
      }
    },
    // 获取展商信息
    async getExhibitorInfo(id) {
      const params = { id };
      try {
        const { data } = await getExhibitor(params);
        this.exhibitorInfo = data.data;
        var arr = [];
        data.data.hzBoothList.map((item) => {
          arr.push(item.boothNum);
        });
        this.exhibitorInfo.boothList = arr;
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.exhibitiorDetail {
  margin-top: 13.3vw;
  .productsDetail {
    margin: 0 auto;

    .nav {
      padding: 4vw;
      box-sizing: border-box;
    }
    .parduct_intr {
      margin-top: 2.4vw;
      padding-left: 4vw;
      padding-right: 4vw;
      padding-bottom: 10.5vw;
      box-sizing: border-box;
      .lunbo {
        width: 100%;
        height: 53.3vw;
        // border: 1px solid red;
        background: #ffffff;
        border: 1px solid #e0e0e0;
        padding-top: 2.6vw;
        padding-bottom: 2.6vw;
        box-sizing: border-box;
        img {
          width: 100%;
          max-height: 100%;
          // height: 424px;
          // margin-top: 48px;ss
        }
        .swiper-container {
          position: relative;
          width: 100%;
          height: 100%;
        }
        .swiper-container .swiper-slide {
          width: 100%;
          line-height: 26.7vw;
          //   background: yellowgreen;
          color: #000;
          font-size: 2.1vw;
          text-align: center;
          padding-left: 13.3vw;
          padding-right: 13.3vw;
          box-sizing: border-box;
        }
        .swiper-button-prev {
          background-image: url('../../../static/ico-leftprevnew.png');
          background-size: 100%;
          width: 5.3vw;
          height: 5.3vw;
          //background-origin:content-box;
        }
        .swiper-button-next {
          background-image: url('../../../static/ico-rightNexnew.png');
          background-size: 100%;
          width: 5.3vw;
          height: 5.3vw;
        }
      }
      .introduce {
        margin-top: 6.4vw;
        width: 100%;
        .title {
          .titleContent {
            font-size: 4.8vw;
            line-height: 4.93vw;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333333;
            width: fit-content;
            display: block;
            border: none;
            padding-bottom: 2vw;
          }
          .border {
            width: 100%;
            height: 0.4vw;
            background: #006fb8;
          }
        }

        p {
          margin-top: 3.9vw;
          font-size: 3.7vw;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333333;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
        }

        .exhibitor {
          width: 100%;
          height: 22.9vw;
          display: flex;
          margin-top: 10.67vw;
          border: 1px solid #e0e0e0;
          .logo {
            width: 29.87vw;
            height: 22.9vw;
            //padding: 0 56px;
            box-sizing: border-box;
            border-right: 1px solid #e0e0e0;
            flex-shrink: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 2.6vw 4.8vw;
            img {
              max-width: 100%;
              max-height: 100%;
            }
          }
          .exhi_title {
            box-sizing: border-box;
            padding-left: 3.9vw;
            padding-bottom: 4vw;
            flex: 1;
            p {
              margin-top: 4vw;
              max-width: 44.7vw;
            }
            .boothnum {
              margin-top: 2.4vw;
            }
          }
        }
      }
    }
    .proInformations {
      margin-top: 10.5vw;
      height: 9.6vw;
      overflow: hidden;
      .anchorPoint {
        width: 100%;
        height: 9.6vw;
        overflow-x: auto;
        overflow-y: hidden;
        position: relative;
        display: flex;
        background-color: #f6f6f7;
        user-select: none;
        .anchorItem {
          width: 27vw;
          height: 9.6vw;
          flex: 1 0 auto;
          position: relative;
          color: #333;
          font-family: Microsoft YaHei;
          font-weight: 400;
          font-size: 3.7vw;
          line-height: 9.6vw;
          cursor: pointer;
          text-align: center;
          list-style: none;
          text-decoration: inherit;
        }
        .anchorItem.active {
          color: #006fb8;
          border-top: 0.7vw solid #006fb8;
          background: #fff;
          box-shadow: 0px 0.3vw 0.7vw 0px rgba(0, 111, 184, 0.35);
          font-family: Microsoft YaHei;
          font-weight: 400;
        }
      }
      .anchorPoint::-webkit-scrollbar {
        display: none;
      }
    }
    // .itemInfo {
    // 展商介绍

    h3 {
      font-size: 4.8vw;
      font-family: Microsoft YaHei;
      font-weight: 400;
      margin-bottom: 6.4vw;
      color: #006fb8;
      width: 24.27vw;
      border-left: 0.4vw solid #006fb8;
      border-right: 0.4vw solid #006fb8;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 4.8vw;
    }
    #item1 {
      margin-top: 6.67vw;
      padding-left: 4vw;
      padding-right: 4vw;
      padding-bottom: 6.67vw;
      padding-top: 4vw;
      box-sizing: border-box;
      .content {
        font-size: 3.7vw;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        line-height: 5vw;
        margin-top: 6.4vw;
        text-indent: 2em;
        p {
          text-indent: 2em;
          font-size: 18px !important;
          span {
            font-size: 18px !important;
          }
        }
        span {
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333333;
          font-size: 3.7vw;
        }
      }
      .vedio {
        width: 100%;
        height: 51.73vw;
        margin: 0 auto;
        margin-top: 11.7vw;
      }

      .shipin {
        width: 100%;
        height: 100%;
      }
      p {
        text-indent: 2em;
      }
    }
    #item2 {
      padding-left: 4vw;
      padding-right: 4vw;
      padding-bottom: 6.6vw;
      padding-top: 4vw;
      box-sizing: border-box;
    }
    #item3 {
      padding-left: 4vw;
      padding-right: 4vw;
      padding-bottom: 6.6vw;
      padding-top: 4vw;
      box-sizing: border-box;

      .down_box {
        .down_thend {
          display: flex;
          height: 8.4vw;
          color: #333333;
          background-color: #fdd000;
          align-items: center;
          padding: 0px 4vw;
          box-sizing: border-box;
          justify-content: space-between;
          p :first-child {
            width: 80%;
          }
          p {
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333333;
            font-size: 3.2vw;
          }
        }
        .down_file {
          background-color: white;
          color: #333;
          border-bottom: 1px solid #e0e0e0;
          height: 11.07vw;
          font-size: 3.2vw;
        }
        a {
          text-decoration: none;
          color: #006fb8;
        }
      }
      .more {
        font-size: 3.7vw;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        margin-left: 36.27vw;
        width: 22vw;
        height: 3.7vw;
        line-height: 3.7vw;

        .icon_more {
          display: inline-block;
          vertical-align: middle;
          width: 0;
          height: 0;
          border: 0.8vw solid transparent; /*5px 足够了*/
          border-top-color: #818895; /*top箭头向下 bottom箭头向上*/
          margin-left: 2vw;
        }

        .icon_more:hover {
          cursor: pointer;
        }
      }
    }
    #item4 {
      padding-left: 4vw;
      padding-right: 4vw;
      padding-bottom: 6.6vw;
      padding-top: 4vw;
      box-sizing: border-box;
      // background: #F6F6F7;
      background: #fff;
      .other_product {
        display: flex;
        overflow-x: scroll;
        width: 100%;
        // background: #F6F6F7;
        background: #fff;
      }
      .other_product::-webkit-scrollbar {
        display: none;
      }
    }
    // }
  }
  .fun {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 15.2vw;
    background: #ffffff;
    box-shadow: 0px 0px 13.3vw 0px rgba(109, 109, 109, 0.35);
    z-index: 99;
    padding: 2.6vw 4vw;
    box-sizing: border-box;
    .collent_btn {
      display: flex;
      button {
        cursor: pointer;
      }
      .shoucang {
        border: none;
        width: 38.67vw;
        height: 9.6vw;
        background: #006fb8;
        border-radius: 4px;
        color: white;
        font-size: 4.3vw;
        z-index: 9;
        &:hover {
          background: #338cc6;
        }
        &:active {
          background: #0064a6;
        }
      }

      .shoucang2 {
        border: none;
        width: 38.67vw;
        height: 9.6vw;
        background: #fdd000;
        border-radius: 4px;
        /*      color: white; */
        color: #006fb8;
        font-size: 4.3vw;
        margin-left: 2.6vw;
        &:hover {
          background: #fdd933;
        }
        &:active {
          background: #e4bb00;
        }
      }

      .shoucang3 {
        background: #ededed;
        border: none;
        width: 38.67vw;
        height: 9.6vw;
        border-radius: 4px;
        color: white;
        font-size: 4.3vw;
        margin-left: 2.6vw;
        &:hover {
          background: #ededed;
        }
      }

      .share {
        margin-left: 5.3vw;
        display: flex;
        flex-direction: column;
        justify-content: center;
        .shareLogo {
          width: 100%;
          height: 4.8vw;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        img {
          color: #666666;
          max-width: 100%;
          max-height: 100%;
          vertical-align: middle;
        }
        .shareTxt {
          font-size: 3.2vw;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #666666;
        }
      }
    }
  }
}
</style>
<style scoped>
.swiper-pagination >>> .my-bullet-active {
  background: #fccf00;
  opacity: 1;
}
.el-table >>> td {
  border-bottom: 1px solid #ebeef5;
  border-right: 0px;
  border-left: 0px;
}

.el-table >>> table {
  border: 0px;
  width: 100% !important;
}
.el-row >>> .el-col-6 {
  width: 25%;
  height: 100%;
  display: flex;
}
div[class*='el-col-'] {
  float: right;
}
/* .content>>>span{
  font-size: 18px !important;
}
.content>>>p{
  font-size: 18px !important;
} */
.tableDate >>> tr:nth-child(2n) > td:nth-last-child(3n-1) {
  background: #e0e0e0;
}
.tableDate >>> tr:nth-child(2n) > td:nth-last-child(2n + 1) {
  background: #e0e0e0;
}
.tableDate >>> td:nth-child(1) {
  display: table-cell;
  text-align: center;
  align-items: center;
}
.el-breadcrumb__item >>> .el-breadcrumb__inner {
  color: #333 !important;
  font-family: Microsoft YaHei;
  font-weight: 400;
}
.van-tabs >>> .van-tabs__line {
  display: none;
}
.van-tabs >>> .van-tab {
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  font-size: 3.7vw;
  background: #f6f6f7;
  width: 25%;
  -webkit-flex: none;
  word-break: break-all;
}
.van-tabs >>> .van-tab--active {
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #006fb8;
  font-size: 3.7vw;
  border-top: 0.7vw solid #006fb8;
  background: #fff;
}
.van-tabs >>> .van-tabs__nav--line.van-tabs__nav--complete {
  padding: 0;
  box-sizing: border-box;
}
.el-breadcrumb >>> .el-breadcrumb__item:nth-child(3) {
  max-width: 55vw;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}
</style>
